import { SxProps, Theme } from "@mui/material";

export const footerContainer: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  justifyContent: "center",
  paddingBottom: "24px",
  paddingLeft: "24px",
  alignSelf: "stretch",
};

export const footerVersionContainer: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",
};

export const footerTextContainer: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "4px",
};

export const footerText: SxProps<Theme> = {
  color: "#000",
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "normal",
};

export const logoStyle: SxProps<Theme> = {
  height: "33px",
};

export const footerVersion: SxProps<Theme> = {
  fontSize: "14px",
};
